module.exports = __webpack_public_path__ + "images/iphone@2x-a481eb.png";